import { render, staticRenderFns } from "./AssignVisit.vue?vue&type=template&id=7421b204&scoped=true&"
import script from "./AssignVisit.vue?vue&type=script&lang=js&"
export * from "./AssignVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7421b204",
  null
  
)

export default component.exports